module.exports = __webpack_public_path__ + "img/send.b4dff352.png";